module.exports = __webpack_public_path__ + "img/default-bank.67376c72.svg";